const DEFAULT_CURRENCY_CODE = "USD";

export const formatCurrency = (
  amount: number,
  currencyCode = DEFAULT_CURRENCY_CODE,
  {
    maximumFractionDigits = 0,
    minimumFractionDigits = 0,
  }: Pick<
    Intl.NumberFormatOptions,
    "maximumFractionDigits" | "minimumFractionDigits"
  > = {},
) =>
  new Intl.NumberFormat("en-US", {
    currency: currencyCode,
    currencyDisplay: "symbol",
    maximumFractionDigits,
    minimumFractionDigits,
    style: "currency",
  }).format(amount);
export const formatTax = (amount: number, currencyCode?: string) =>
  formatCurrency(amount, currencyCode, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
export const formatPoints = (amount: number) =>
  new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(amount);
export const formatCompactPoints = (amount: number) =>
  new Intl.NumberFormat("en-US", {
    compactDisplay: "short",
    maximumFractionDigits: 1,
    notation: "compact",
  })
    .format(amount)
    .toLowerCase();
